<template>
  <div class="sliders calc-main">
    <div
      v-if="!isSubmitted"
      id="sliders-page"
    >
      <section class="calc-main__container">
        <header>
          <h3 class="header-2">Calculate Your Savings Needs</h3>
          <p class="">
            <strong>Note:</strong> Calculators display default values. Enter new figures to override.
          </p>
        </header>
        <form
          class="form_wrapper"
          action
        >
          <div class="row">
            <div class="col-12 col-md-6 input-fields">
              <div
                id="input"
                class="input__wrapper save"
              >
                <nav>
                  <div
                    id="results-nav-tab"
                    class="nav nav-tabs"
                    role="tablist"
                  >
                    <a
                      id="nav-months-to-goal-tab"
                      class="nav-item nav-link"
                      :class="{ 'active': tab === 0 }"
                      data-toggle="tab"
                      href="#nav-months-to-goal"
                      role="tab"
                      aria-controls="nav-months-to-goal"
                      aria-selected="true"
                      @click="monthsToGoalTab"
                    >Months To Goal</a>
                    <a
                      id="nav-monthly-deposit-tab"
                      class="nav-item nav-link"
                      :class="{ 'active': tab === 1 }"
                      data-toggle="tab"
                      href="#nav-monthly-deposit"
                      role="tab"
                      aria-controls="nav-monthly-deposit"
                      aria-selected="false"
                      @click="monthlyDepositTab"
                    >Monthly Deposit</a>
                  </div>
                </nav>
                <div
                  id="nav-tabContent"
                  class="tab-content"
                >
                  <div
                    id="nav-months-to-goal"
                    class="tab-pane"
                    :class="{ 'show active': tab === 0 }"
                    role="tabpanel"
                    aria-labelledby="nav-months-to-goal-tab"
                  >
                    <div
                      id="Months-to-Goal-input-group"
                      class="form-group"
                    >
                      <label for="Months-to-Goal-input-field">
                        Months To Goal
                        <span
                          class="tooltipContent"
                          data-toggle="tooltip"
                          data-placement="right"
                          aria-hidden="true"
                          data-html="true"
                          title="<p>Number of months until you plan to buy a home.</p>"
                        >
                          <i class="fa fa-info-circle fa-1x" />
                        </span>
                      </label>
                      <div class="input-group mb-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text">&nbsp;</div>
                        </div>
                        <input
                          id="Months-to-Goal-input-field"
                          v-model.number="$v.monthsToGoal.$model"
                          type="number"
                          class="form-control"
                          :class="{'is-invalid': $v.monthsToGoal.$error || $v.monthsToGoal.$invalid}"
                          @input="calculateMonthlyDeposit"
                        >
                        <div class="input-group-append">
                          <div class="input-group-text">&nbsp;</div>
                        </div>
                        <input
                          id="Months-to-Goal-input-range"
                          v-model.number="monthsToGoal"
                          type="range"
                          class="custom-range"
                          min="2"
                          max="60"
                          value="10"
                          @input="calculateMonthlyDeposit"
                        >
                        <div class="invalid-feedback">
                          <span
                            v-if="!$v.monthsToGoal.between || !$v.monthsToGoal.required"
                          >
                            {{ 'Please enter a valid month between' }} {{ Number($v.monthsToGoal.$params.between.min
                            ).toLocaleString()
                            }}
                            and {{ Number( $v.monthsToGoal.$params.between.max
                            ).toLocaleString()
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="nav-monthly-deposit"
                    class="tab-pane"
                    :class="{'show active': tab === 1 }"
                    role="tabpanel"
                    aria-labelledby="nav-monthly-deposit-tab"
                  >
                    <div
                      id="deposit-amount-input-group"
                      class="form-group"
                    >
                      <label for="deposit-amount-input-field">
                        Deposit Amount
                        <span
                          class="tooltipContent"
                          data-toggle="tooltip"
                          data-placement="right"
                          aria-hidden="true"
                          data-html="true"
                          title="<p>The amount you need to save each month to meet your financial goal.</p>"
                        >
                          <i class="fa fa-info-circle fa-1x" />
                        </span>
                      </label>
                      <div class="input-group mb-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text">$</div>
                        </div>
                        <CurrencyComponent
                          v-model.number="$v.depositAmount.$model"
                          class="form-control"
                          :class="{ 'is-invalid': $v.depositAmount.$error || $v.depositAmount.$invalid }"
                          @input="calculateMonthsToGoal"
                        />
                        <div class="input-group-append">
                          <div class="input-group-text">/MO</div>
                        </div>
                        <input
                          id="deposit-amount-input-range"
                          v-model.number="depositAmount"
                          type="range"
                          class="custom-range"
                          min="10"
                          max="10000"
                          value="1187"
                          @input="calculateMonthsToGoal"
                        >
                        <div class="invalid-feedback">
                          <span
                            v-if="!$v.depositAmount.between || !$v.depositAmount.required"
                          >
                            {{ errorMsgPre }} ${{ Number($v.depositAmount.$params.between.min
                            ).toLocaleString()
                            }}
                            and ${{ Number( $v.depositAmount.$params.between.max
                            ).toLocaleString()
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="current-savings-input-group"
                  class="form-group"
                >
                  <label for="current-savings-input-field">
                    Current Savings
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Enter the amount you currently have available for your down payment.</p>"
                    >
                      <i class="fa fa-info-circle fa-1x" />
                    </span>
                  </label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <CurrencyComponent
                      v-model.number="$v.currentSavings.$model"
                      class="form-control"
                      :class="{
                        'is-invalid': $v.currentSavings.$error || $v.currentSavings.$invalid
                      }"
                      @input="currentSavingsDynamics"
                    />
                    <div class="input-group-append">
                      <div class="input-group-text">&nbsp;</div>
                    </div>
                    <input
                      id="current-savings-input-range"
                      v-model.number="currentSavings"
                      type="range"
                      class="custom-range"
                      min="0"
                      max="500000"
                      @input="currentSavingsDynamics"
                    >
                    <div class="invalid-feedback">
                      <span v-if="!$v.currentSavings.between || !$v.currentSavings.required">
                        {{ errorMsgPre }} ${{ Number($v.currentSavings.$params.between.min
                        ).toLocaleString()
                        }}
                        and ${{ Number( $v.currentSavings.$params.between.max
                        ).toLocaleString()
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  id="home-purchase-price-input-group"
                  class="form-group"
                >
                  <label for="home-purchase-price-input-field">
                    Home Purchase Price
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Enter the amount you plan to pay for the home.</p>"
                    >
                      <i class="fa fa-info-circle fa-1x" />
                    </span>
                  </label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <CurrencyComponent
                      v-model.number="$v.homePurchasePrice.$model"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          $v.homePurchasePrice.$error || $v.homePurchasePrice.$invalid
                      }"
                      @input="calculateClosingCostAndPostClosingReserve"
                    />
                    <div class="input-group-append">
                      <div class="input-group-text">&nbsp;</div>
                    </div>
                    <input
                      id="home-purchase-price-input-range"
                      v-model.number="homePurchasePrice"
                      type="range"
                      class="custom-range"
                      min="10000"
                      max="1000000"
                      @input="calculateClosingCostAndPostClosingReserve"
                    >
                    <div class="invalid-feedback">
                      <span
                        v-if="
                          !$v.homePurchasePrice.between || !$v.homePurchasePrice.required
                        "
                      >
                        {{ errorMsgPre }} ${{ Number($v.homePurchasePrice.$params.between.min
                        ).toLocaleString()
                        }}
                        and ${{ Number( $v.homePurchasePrice.$params.between.max
                        ).toLocaleString()
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  id="down-payment-input-group"
                  class="form-group"
                >
                  <label for="down-payment-input-field">
                    Down Payment %
                    <span
                      class="tooltipContent"
                      data-toggle="tooltip"
                      data-placement="right"
                      aria-hidden="true"
                      data-html="true"
                      title="<p>Enter the percentage of the sales price you plan to contribute toward the purchase of your home.</p><p>Note: 5% is the default setting, but the applicable percentage will be determined by the type of loan your lender offers and your resources to apply to the down payment. If your down payment is less than 20%, you may be required to pay mortgage insurance.</p>"
                    >
                      <i class="fa fa-info-circle fa-1x" />
                    </span>
                  </label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">&nbsp;</div>
                    </div>
                    <input
                      id="down-payment-input-field"
                      v-model.number="$v.downPaymentPercent.$model"
                      type="number"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          $v.downPaymentPercent.$error ||
                          $v.downPaymentPercent.$invalid
                      }"
                      @input="downPaymentDynamics"
                    >
                    <div class="input-group-append">
                      <div class="input-group-text">%</div>
                    </div>
                    <input
                      id="down-payment-input-range"
                      v-model.number="downPaymentPercent"
                      type="range"
                      class="custom-range"
                      min="3"
                      max="50"
                      step="0.25"
                      @input="downPaymentDynamics"
                    >
                    <div class="invalid-feedback">
                      <span
                        v-if="
                          !$v.downPaymentPercent.between ||
                            !$v.downPaymentPercent.required
                        "
                      >
                        {{ errorMsgPre }}
                        {{ Number($v.downPaymentPercent.$params.between.min
                        ).toLocaleString()
                        }}% and
                        {{ Number( $v.downPaymentPercent.$params.between.max
                        ).toLocaleString()
                        }}%
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="!simpleView"
                  class="advanced"
                >
                  <div
                    id="closing-costs-input-group"
                    class="form-group"
                  >
                    <label for="closing-costs-input-field">
                      Closing Costs
                      <span
                        class="tooltipContent"
                        data-toggle="tooltip"
                        data-placement="right"
                        aria-hidden="true"
                        data-html="true"
                        title="<p>Enter the estimated amount of funds required to close on your home—which include fees charged by the lender, title company, local government, and others involved in the sale.</p><hr><p>The default setting is 2.5% of the value you entered for the home purchase price. Expect to receive the HUD-1 form, which lists actual figures associated with the home sale and closing costs, from your lender a day or two before your closing date. Ask your lender about the method of payment and to confirm when these fees need to be paid.</p>"
                      >
                        <i class="fa fa-info-circle fa-1x" />
                      </span>
                    </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <CurrencyComponent
                        v-model.number="$v.closingCosts.$model"
                        class="form-control"
                        :class="{'is-invalid': $v.closingCosts.$error || $v.closingCosts.$invalid}"
                        @input="closingCostsDynamics"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <input
                        id="closing-costs-input-range"
                        v-model.number="closingCosts"
                        type="range"
                        class="custom-range"
                        min="100"
                        max="50000"
                        value="5000"
                        @input="closingCostsDynamics"
                      >
                      <div class="invalid-feedback">
                        <span
                          v-if=" !$v.closingCosts.between || !$v.closingCosts.required"
                        >
                          {{ errorMsgPre }} ${{ Number( $v.closingCosts.$params.between.min
                          ).toLocaleString()
                          }}
                          and ${{ Number( $v.closingCosts.$params.between.max
                          ).toLocaleString()
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="interest-rate-input-group"
                    class="form-group"
                  >
                    <label for="interest-rate-input-field">
                      Interest Rate
                      <span
                        class="tooltipContent"
                        data-toggle="tooltip"
                        data-placement="right"
                        aria-hidden="true"
                        data-html="true"
                        title="<p>Enter the estimated annual interest rate you expect to pay your lender for a mortgage loan.  This rate excludes other fees such as mortgage insurance, closing costs, loan origination fees, etc.</p><p>Interest rates can vary and are determined by a number of factors including the loan term and type, credit score, down payment, points, and home price. For current interest rates, visit your local bank, credit union, mortgage company, or check online.</p>"
                      >
                        <i class="fa fa-info-circle fa-1x" />
                      </span>
                    </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">&nbsp;</div>
                      </div>

                      <input
                        id="interest-rate-input-field"
                        v-model.number="$v.interestRatePercent.$model"
                        type="number"
                        step="0.25"
                        class="form-control"
                        :class="{ 'is-invalid': $v.interestRatePercent.$error || $v.interestRatePercent.$invalid }"
                      >
                      <div class="input-group-append">
                        <div class="input-group-text">%</div>
                      </div>
                      <input
                        id="interest-rate-input-range"
                        v-model.number="interestRatePercent"
                        type="range"
                        class="custom-range"
                        min="1"
                        max="11"
                        step="0.25"
                      >
                      <div class="invalid-feedback">
                        <span
                          v-if=" !$v.interestRatePercent.between || !$v.interestRatePercent.required"
                        >
                          {{ 'Please enter a valid interest rate between' }}
                          {{ Number( $v.interestRatePercent.$params.between.min).toLocaleString()
                          }}% and
                          {{ Number( $v.interestRatePercent.$params.between.max).toLocaleString()
                          }}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="term-input-group"
                    class="form-group"
                  >
                    <label for="term-input-select">
                      Term
                      <span
                        class="tooltipContent"
                        data-toggle="tooltip"
                        data-placement="right"
                        aria-hidden="true"
                        data-html="true"
                        title="<p>Select the length of the loan repayment period.</p><p>Loan terms affect your monthly payment. A longer term mortgage (30-year) means lower principal payments each month, but you will pay more in interest over the life of the loan. A shorter term mortgage (15-year) means monthly principal payments are higher but the amount of interest paid over the life of the loan is lower.</p>"
                      >
                        <i class="fa fa-info-circle fa-1x" />
                      </span>
                    </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <select
                        id="term-input-select"
                        v-model.number="term"
                        class="form-control"
                      >
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option selected>30</option>

                      </select>
                      <div class="input-group-append">
                        <div class="input-group-text">YRS</div>
                      </div>
                      <input
                        id="term-input-range"
                        v-model.number="term"
                        type="range"
                        class="custom-range"
                        min="10"
                        max="30"
                        step="5"
                      >
                    </div>
                  </div>
                  <div
                    id="post-closing-reserves-input-group"
                    class="form-group"
                  >
                    <label for="post-closing-reserves-input-field">
                      Post Closing Reserves
                      <span
                        class="tooltipContent"
                        data-toggle="tooltip"
                        data-placement="right"
                        aria-hidden="true"
                        data-html="true"
                        title="<p>Enter the estimated amount that a lender may require you to have, in addition to your down payment and closing costs—typically 2 to 6 months of mortgage payments.</p><hr><p>Closing reserve requirements will vary depending on the loan type. Speak with your lender for more details.</p>"
                      >
                        <i class="fa fa-info-circle fa-1x" />
                      </span>
                    </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <CurrencyComponent
                        v-model.number="$v.postClosingReserves.$model"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.postClosingReserves.$error || $v.postClosingReserves.$invalid
                        }"
                        @input="postClsoingReservesDynamics"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">&nbsp;</div>
                      </div>
                      <input
                        id="post-closing-reserves-input-range"
                        v-model.number="postClosingReserves"
                        type="range"
                        class="custom-range"
                        min="0"
                        max="20000"
                        value="1869.37"
                        @input="postClsoingReservesDynamics"
                      >
                      <div class="invalid-feedback">
                        <span
                          v-if="
                            !$v.postClosingReserves.between ||
                              !$v.postClosingReserves.required
                          "
                        >
                          {{ errorMsgPre }} ${{ Number( $v.postClosingReserves.$params.between.min
                          ).toLocaleString()
                          }}
                          and ${{ Number( $v.postClosingReserves.$params.between.max
                          ).toLocaleString()
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="result"
              class="col-12 col-md-6"
            >
              <div class="sticky">
                <div class="card-main graph">
                  <div class="card-bottom">
                    <div class="row graph-content">
                      <GraphComponent
                        :values="graphDataValues"
                        :center-text="graphDataCenterText"
                      />
                    </div>
                    <div>
                      <div class="row result-value">
                        <label class="big">Current Savings</label>
                        <span class="big">
                          {{ currencyFormat(currentSavings) }}
                        </span>
                      </div>
                      <div class="row result-value">
                        <label class="big">Savings Goal</label>
                        <span class="big">{{ currencyFormat(additionalSavings) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row donut-loan align-center">
                  <div class="col-6 donut-loan__item">
                    <span class="donut-loan__label">Monthly Deposit</span>
                    <span class="donut-loan__value">
                      {{ currencyFormat(monthlyDepositAmount)
                      }}</span>
                  </div>
                  <div class="col-6 donut-loan__item">
                    <span class="donut-loan__label">Months to Goal</span>
                    <span class="donut-loan__value">{{ Math.ceil(targetMonthsToGoal)
                    }}</span>
                  </div>
                </div>
                <div class="row">
                  <div
                    id="submit-form-group"
                    class="form-group col col-12"
                  >
                    <button
                      class="btn large dark"
                      type="submit"
                      :disabled="$v.$invalid"
                      onclick="dataLayer.push({'event': 'calculator-cta-link', 'calculatorName': 'Savings calculator', 'calculatorCta' : 'Results'});"
                      @click.prevent="isSubmitted = !isSubmitted"
                    >
                      Results →
                    </button>
                  </div>
                  <div class="col col-sm-6">
                    <button
                      type="button"
                      class="btn small"
                      @click="simpleView = !simpleView, sendDataLayer(simpleView)"
                    >
                      {{ simpleView ? "Advanced View" : "Simple View" }}
                    </button>
                  </div>
                  <div class="col col-sm-6 align-right">
                    <button
                      type="button"
                      class="btn small dull"
                      onclick="dataLayer.push({'event': 'calculator-cta-link', 'calculatorName': 'Savings calculator', 'calculatorCta' : 'Reset'});"
                      @click="reset"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
    <div
      v-if="isSubmitted"
      id="result-page"
    >
      <div class="calc-main results__page">
        <section class="calc-main__container">
          <header>
            <h3 class="header-2">Calculate Your Savings Needs</h3>
            <p class="">
              <strong>Note:</strong> Calculators display default values. Enter new figures to override.
            </p>
          </header>
          <div class="col results__wrapper">
            <div class="block-main">
              <div class="block-main-header">
                <h3>Information about your savings goal:</h3>
              </div>
              <div class="block-main-content">
                <div class="row result-value">
                  <label class="big">Additional Savings Required</label>
                  <span class="big">{{ currencyFormat(additionalSavings) }}</span>
                </div>
                <div class="row result-value">
                  <label class="big">Months to Goal</label>
                  <span class="big">{{ Math.ceil(targetMonthsToGoal) }} MO</span>
                </div>
                <div class="row result-value">
                  <label class="big">Deposit Amount</label>
                  <span class="big">{{ currencyFormat(monthlyDepositAmount) }}/MO</span>
                </div>
              </div>
              <div class="block-main-header">
                <h3>What you shared about your financial situation:
                </h3>
              </div>
              <div class="block-main-content">
                <div class="row result-value">
                  <label class="big">Current Savings</label>
                  <span class="big">{{ currencyFormat(currentSavings) }}</span>
                </div>
              </div>
              <div class="block-main-header">
                <h3>Expected funds needed at closing:</h3>
              </div>
              <div class="block-main-content">
                <div class="row result-value">
                  <label class="big">Total funds at closing</label>
                  <span class="big">{{ currencyFormat(fundsAtClosing) }}</span>
                </div>
                <div class="block-main-content--padded">
                  <div class="row result-value">
                    <label class="">Down Payment</label>
                    <span class="">{{ currencyFormat(downPayment) }}</span>
                  </div>
                  <div class="row result-value">
                    <label class="">Closing Costs</label>
                    <span class="">{{ currencyFormat(closingCosts) }}</span>
                  </div>
                  <div class="row result-value">
                    <label class="">Post Closing Reserves</label>
                    <span class="">{{ currencyFormat(postClosingReserves) }}</span>
                  </div>
                </div>
              </div>
              <div class="block-main-header">
                <h3>Information about your potential mortgage:</h3>
              </div>
              <div class="block-main-content">
                <div class="row result-value">
                  <label class="big">Home Purchase Amount</label>
                  <span class="big">{{ currencyFormat(homePurchasePrice) }}</span>
                </div>
                <div class="row result-value">
                  <label class="big">Mortgage Loan Amount</label>
                  <span class="big">{{ currencyFormat(mortgageLoanAmount) }}</span>
                </div>
                <div class="row result-value">
                  <label class="big">Principal & Interest (P&I) Payment</label>
                  <span class="big">{{ currencyFormat(piPaymentMonthly) }}/MO</span>
                </div>
                <div class="row result-value">
                  <label class="big">Term</label>
                  <span class="big">{{ term }} YRS</span>
                </div>
                <div class="row result-value">
                  <label class="big">Interest Rate</label>
                  <span class="big">{{ formatNumber( interestRatePercent ) }}%</span>
                </div>
                <div class="row result-value">
                  <label class="big">LTV</label>
                  <span class="big">{{ formatNumber(ltv) }}%</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 backBtn">
                <button
                  class="btn dark large"
                  type="submit"
                  onclick="dataLayer.push({'event': 'calculator-cta-link', 'calculatorName': 'Savings calculator', 'calculatorCta' : 'Back to Calculator'});"
                  @click.prevent="isSubmitted = !isSubmitted"
                >
                  ← Calculator
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>


<script>
import jQuery from 'jquery';
import { required, between } from 'vuelidate/lib/validators';
import GraphComponent from '../components/GraphComponent.vue';
import CurrencyComponent from '../components/Currency.vue';

const $ = jQuery;
const currency = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  style: 'currency',
  currency: 'USD',
});
export default {
  name: 'SaveCalculator',
  components: {
    GraphComponent,
    CurrencyComponent,
  },
  data() {
    return this.init();
  },
  validations: {
    monthsToGoal: {
      required,
      between: between(2, 60),
    },
    depositAmount: {
      required,
      between: between(10, 10000),
    },
    currentSavings: {
      required,
      between: between(0, 500000),
    },
    homePurchasePrice: {
      required,
      between: between(10000, 1000000),
    },
    downPaymentPercent: {
      required,
      between: between(3, 50),
    },
    closingCosts: {
      required,
      between: between(100, 50000),
    },
    interestRatePercent: {
      required,
      between: between(1, 11),
    },
    postClosingReserves: {
      required,
      between: between(0, 20000),
    },
  },
  computed: {
    downPayment() {
      const down = this.homePurchasePrice * (this.downPaymentPercent / 100);
      return this.handleNegativeNums(down);
    },
    mortgageLoanAmount() {
      const loan = this.homePurchasePrice - this.downPayment;
      return this.handleNegativeNums(loan);
    },
    ltv() {
      return (this.mortgageLoanAmount / this.homePurchasePrice) * 100;
    },
    fundsAtClosing() {
      if (
        !this.$v.closingCosts.$invalid &&
        !this.$v.postClosingReserves.$invalid &&
        !this.$v.homePurchasePrice.$invalid
      ) {
        return (
          parseFloat(this.downPayment) +
          parseFloat(this.closingCosts) +
          parseFloat(this.postClosingReserves)
        );
      }
      return 0;
    },
    additionalSavings() {
      return this.handleNegativeNums(this.fundsAtClosing - this.currentSavings);
    },
    piPaymentMonthly() {
      let payment = 0;
      const termInMonths = this.term * 12;
      const principal = this.homePurchasePrice - this.downPayment;
      const monthlyInterest = this.interestRatePercent / 1200;
      payment =
        (principal * monthlyInterest) /
        (1 - (1 / (1 + monthlyInterest)) ** termInMonths);
      return payment;
    },
    graphDataValues() {
      let savingsCurrent = 0;
      let savingsAdditional = 0;
      savingsCurrent = this.currentSavings;
      savingsAdditional = this.additionalSavings;
      if (this.additionalSavings <= 0) {
        savingsAdditional = 1;
      }

      if (this.currentSavings <= 0 || this.currentSavings === '') {
        savingsCurrent = 1;
      }
      const valOne = Object();
      valOne.value = savingsCurrent;
      valOne.color = '#05314d';

      const valTwo = Object();
      valTwo.value = savingsAdditional;
      valTwo.color = '#2b94d5';

      // eslint-disable-next-line
      const values = Array();
      values[0] = valOne;
      values[1] = valTwo;
      return values;
    },
    graphDataCenterText() {
      // eslint-disable-next-line
      const centerText = Array();
      centerText[0] = 'Down Payment';
      centerText[1] = 'Cash Needed';
      centerText[2] = this.fundsAtClosing;

      return centerText;
    },
  },
  mounted() {
    $('.sliders').tooltip({ selector: '[data-toggle="tooltip"]' });
  },
  methods: {
    init() {
      return {
        isSubmitted: false,
        monthsToGoal: 10,
        targetMonthsToGoal: 10,
        depositAmount: 1187,
        monthlyDepositAmount: 1187,
        currentSavings: 5000,
        homePurchasePrice: 200000,
        downPaymentPercent: 5,
        closingCosts: 5000,
        interestRatePercent: 4.25,
        term: 30,
        postClosingReserves: 1869.37,
        simpleView: true,
        closingCostMultiplier: 0.025,
        errorMsgPre: 'Please enter a valid amount between',
        tab: 0,
      };
    },
    reset() {
      this.monthsToGoal = this.init().monthsToGoal;
      this.targetMonthsToGoal = this.init().targetMonthsToGoal;
      this.depositAmount = this.init().depositAmount;
      this.monthlyDepositAmount = this.init().monthlyDepositAmount;
      this.currentSavings = this.init().currentSavings;
      this.homePurchasePrice = this.init().homePurchasePrice;
      this.downPaymentPercent = this.init().downPaymentPercent;
      this.closingCosts = this.init().closingCosts;
      this.interestRatePercent = this.init().interestRatePercent;
      this.term = this.init().term;
      this.postClosingReserves = this.init().postClosingReserves;
    },
    calculateClosingCostAndPostClosingReserve() {
      if (!this.$v.homePurchasePrice.$invalid) {
        this.closingCosts = (
          this.homePurchasePrice * this.closingCostMultiplier
        ).toFixed(2);
        this.postClosingReserves = (this.piPaymentMonthly * 2).toFixed(2);
        if (this.currentSavings + 1 >= this.fundsAtClosing) {
          this.monthlyDepositAmount = 0;
          this.targetMonthsToGoal = 0;
          return;
        }
        if (this.tab === 0) {
          this.calculateMonthlyDeposit();
        }
        if (this.tab === 1) {
          this.calculateMonthsToGoal();
        }
      }
    },
    downPaymentDynamics() {
      if (this.tab === 0) {
        this.calculateMonthlyDeposit();
      }
      if (this.tab === 1) {
        this.calculateMonthsToGoal();
      }
    },
    currentSavingsDynamics() {
      if (this.currentSavings + 1 >= this.fundsAtClosing) {
        this.monthlyDepositAmount = 0;
        this.targetMonthsToGoal = 0;
        return;
      }
      if (this.tab === 0) {
        this.calculateMonthlyDeposit();
      }
      if (this.tab === 1) {
        this.calculateMonthsToGoal();
      }
    },
    closingCostsDynamics() {
      if (!this.$v.closingCosts.$invalid) {
        if (this.tab === 0) {
          this.calculateMonthlyDeposit();
        }
        if (this.tab === 1) {
          this.calculateMonthsToGoal();
        }
      }
    },
    postClsoingReservesDynamics() {
      if (this.tab === 0) {
        this.calculateMonthlyDeposit();
      }
      if (this.tab === 1) {
        this.calculateMonthsToGoal();
      }
    },
    calculateMonthlyDeposit() {
      if (!this.$v.monthsToGoal.$invalid) {
        this.monthlyDepositAmount = this.additionalSavings / this.monthsToGoal;
        this.targetMonthsToGoal = this.monthsToGoal;
      }
    },
    calculateMonthsToGoal() {
      if (!this.$v.depositAmount.$invalid) {
        this.targetMonthsToGoal = this.additionalSavings / this.depositAmount;
        this.monthlyDepositAmount = this.depositAmount;
      }
    },
    monthsToGoalTab() {
      this.tab = 0;
      this.calculateMonthlyDeposit();
    },
    monthlyDepositTab() {
      this.tab = 1;
      this.calculateMonthsToGoal();
    },
    handleNegativeNums(n) {
      if (n < 0) {
        return 0;
      }
      return n;
    },
    currencyFormat(n) {
      return currency.format(n);
    },
    formatNumber(num) {
      return Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    sendDataLayer(view) {
      const viewName = view ? 'Simple' : 'Advanced';
      window.dataLayer.push({
        event: 'calculator-cta-link',
        calculatorName: 'Savings calculator',
        calculatorCta: viewName,
      });
    },
  },
};
</script>
<style lang="sass">
</style>
